const translations = {
  de_DE: {
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    termsAndConditions: 'AGB',
  },
}

export default translations
